/* SHOPIFY MONEY FORMATTER */
if (typeof Shopify.formatMoney === "undefined") {
  Shopify.formatMoney = function(cents) {
    if (!cents) return "0";
    return (cents / 100).toLocaleString("en-IN", {
      style: "currency",
      currency: "INR"
    });
  };
}

document.addEventListener("DOMContentLoaded", function () {

  /* VARIANT CHANGE */
  const variantSelectors = document.querySelectorAll(".bs-variant-select");

  variantSelectors.forEach(select => {
    select.addEventListener("change", function () {
        /* 🔥 SYNC DEFAULT VARIANT ON PAGE LOAD */
        


      const productId = this.dataset.productId;
      const selected = this.selectedOptions[0];

      const newPrice = selected.dataset.price;
      const newCompare = selected.dataset.compare;
      const newImage = selected.dataset.image;
      const stock = selected.dataset.stock === "true";

      const imgEl = document.querySelector(`.product-image-${productId}`);
      const priceEl = document.querySelector(`.product-price-${productId}`);
      const compareEl = document.querySelector(`.product-compare-${productId}`);
      const oosEl = document.querySelector(`.product-oos-${productId}`);
      const quickBtn = this.parentElement.querySelector(".bs-add-btn");

      /* Image */
      if (newImage) imgEl.src = newImage;

      /* Price */
      priceEl.innerHTML = Shopify.formatMoney(newPrice);

      /* Compare Price */
      if (newCompare && parseInt(newCompare) > parseInt(newPrice)) {
        compareEl.innerHTML = Shopify.formatMoney(newCompare);
        compareEl.style.display = "inline-block";
      } else {
        compareEl.style.display = "none";
      }

      /* Stock check */
      if (!stock) {
        quickBtn.classList.add("disabled");
        oosEl.style.display = "block";
      } else {
        quickBtn.classList.remove("disabled");
        oosEl.style.display = "none";
      }
    });
  });


  /* QUICK ADD */
  const quickButtons = document.querySelectorAll(".bs-add-btn");

  quickButtons.forEach(btn => {
    btn.addEventListener("click", async function () {

      if (btn.classList.contains("disabled")) return;

      const select = this.parentElement.querySelector(".bs-variant-select");
      const variantId = select.value;

     await fetch("/cart/add.js", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    items: [{ id: variantId, quantity: 1 }]
  }),
});


// 🔥 Update cart bubble after successful add
updateCartBubble();

    });
  });


  /* NEXT / PREV SCROLL */
  const slider = document.getElementById("bsSlider");
  const nextBtn = document.getElementById("bsNext");
  const prevBtn = document.getElementById("bsPrev");

  function getSlideWidth() {
    const card = slider.querySelector(".bs-card");
    if (!card) return 300;
    return card.offsetWidth + 30;
  }

  nextBtn.addEventListener("click", () => {
    slider.scrollBy({ left: getSlideWidth() * 3, behavior: "smooth" });
  });

  prevBtn.addEventListener("click", () => {
    slider.scrollBy({ left: -getSlideWidth() * 3, behavior: "smooth" });
  });

});
